export default __webpack_public_path__ + "static/media/_hired.37e4140d.png";